import {
  LayoutDashboard, PlusCircle, Truck, Users, BarChart3, CalendarDays, FileText, UserCog, Contact, Building2, BookUser,
  ClipboardList, Archive, History, Sparkles, Activity, Tag, GraduationCap, Briefcase, Settings2, MailCheck, ListChecks, LineChart, Hospital, KeyRound,
} from "lucide-react";

const adminOnly = (isOperatore, items) => (isOperatore ? [] : items);

export const buildNavItems = ({ isAdmin, isOperatore }) => {
  if (!isAdmin) {
    return [
      { to: "/partner", label: "Corse Disponibili", icon: Truck },
      { to: "/partner/archivio", label: "Trasporti Archiviati", icon: Archive },
    ];
  }
  const items = [
    { to: "/operativa", label: "Dashboard", icon: LayoutDashboard },
    { to: "/operativa/calendario", label: "Calendario", icon: CalendarDays },
    { to: "/operativa/nuova", label: "Nuova Richiesta", icon: PlusCircle },
    {
      group: "Analisi e Registri", icon: LineChart, children: [
        { to: "/operativa/statistiche", label: "Statistiche", icon: BarChart3 },
        { to: "/operativa/log-corse", label: "Log Azioni Corse", icon: History },
        { to: "/operativa/log-strutture", label: "Registro Portale Strutture", icon: Hospital },
        ...adminOnly(isOperatore, [
          { to: "/operativa/insights", label: "Insights", icon: Sparkles },
          { to: "/operativa/log-email", label: "Registro Invii Email", icon: MailCheck },
        ]),
      ],
    },
    { to: "/operativa/report", label: "Report Partner", icon: FileText },
    { to: "/operativa/report-richiedenti", label: "Report Richiedenti", icon: ClipboardList },
    { to: "/operativa/formazione", label: "Formazione", icon: GraduationCap },
    ...adminOnly(isOperatore, [{
      group: "Amministrazione", icon: Briefcase, children: [
        { to: "/operativa/amministrazione/preventivi", label: "Preventivi", icon: FileText },
        { to: "/operativa/amministrazione/tariffe", label: "Configurazione Tariffe", icon: Settings2 },
      ],
    }]),
    {
      group: "Anagrafiche", icon: BookUser, children: [
        { to: "/operativa/pazienti", label: "Anagrafica Pazienti", icon: Contact },
        { to: "/operativa/richiedenti", label: "Anagrafica Richiedenti", icon: Building2 },
        { to: "/operativa/enti", label: "Enti / Indirizzi", icon: Building2 },
        { to: "/operativa/opzioni", label: "Mezzi e Mobilizzazione", icon: Truck },
        { to: "/operativa/attivita", label: "Attività", icon: Activity },
        { to: "/operativa/causali", label: "Causali", icon: Tag },
        ...adminOnly(isOperatore, [
          { to: "/operativa/partner", label: "Gestione Partner", icon: Users },
          { to: "/operativa/liste-partner", label: "Liste Partner", icon: ListChecks },
          { to: "/operativa/staff", label: "Anagrafica Staff", icon: UserCog },
          { to: "/operativa/strutture-accessi", label: "Accessi Strutture", icon: KeyRound },
        ]),
      ],
    },
  ];
  return items.filter((it) => !it.children || it.children.length > 0);
};

// Rotte dinamiche (con :id) → breadcrumb. `label` usa crumbLabel quando disponibile.
const DYNAMIC_CRUMBS = [
  { test: (p) => p.startsWith("/operativa/richiesta/") && p.endsWith("/modifica"),
    build: (p, l) => [{ label: l || "Dettaglio richiesta", to: p.replace(/\/modifica$/, "") }, { label: "Modifica" }] },
  { test: (p) => p.startsWith("/operativa/richiesta/"), build: (p, l) => [{ label: l || "Dettaglio richiesta" }] },
  { test: (p) => p.startsWith("/operativa/evento/") && p.endsWith("/modifica"),
    build: (p, l) => [{ label: l || "Dettaglio evento", to: p.replace("/evento/", "/richiesta/").replace(/\/modifica$/, "") }, { label: "Modifica evento" }] },
  { test: (p) => p.startsWith("/operativa/amministrazione/preventivi-eventi/"),
    build: (p, l) => [{ label: "Amministrazione" }, { label: "Preventivi Eventi", to: "/operativa/amministrazione/preventivi?tipo=evento" }, { label: l || "Preventivo evento" }] },
  { test: (p) => p.startsWith("/operativa/amministrazione/preventivi/"),
    build: (p, l) => [{ label: "Amministrazione" }, { label: "Preventivi", to: "/operativa/amministrazione/preventivi" }, { label: l || "Preventivo" }] },
  { test: (p) => p.startsWith("/operativa/formazione/"), build: (p, l) => [{ label: "Formazione", to: "/operativa/formazione" }, { label: l || "Cliente" }] },
  { test: (p) => p.startsWith("/operativa/strutture/richieste/"), build: (p, l) => [{ label: "Portale Strutture" }, { label: l || "Richiesta struttura" }] },
  { test: (p) => p === "/operativa/nuovo-evento", build: () => [{ label: "Nuovo Evento" }] },
  { test: (p) => p === "/operativa/importa", build: () => [{ label: "Importazione Excel" }] },
];

export const buildCrumbs = ({ pathname, navItems, homePath, isAdmin, crumbLabel }) => {
  const home = { label: isAdmin ? "Dashboard" : "Corse Disponibili", to: homePath };
  const flat = navItems.flatMap((it) => (it.children ? it.children.map((c) => ({ ...c, group: it.group })) : [it]));
  const hit = flat.find((it) => it.to === pathname && it.to !== homePath);
  if (hit) return hit.group ? [home, { label: hit.group }, { label: hit.label }] : [home, { label: hit.label }];
  const dyn = DYNAMIC_CRUMBS.find((d) => d.test(pathname));
  return dyn ? [home, ...dyn.build(pathname, crumbLabel)] : [home];
};
